// Types
import { IMarketplaceReviewsPost } from "../interfaces";

export default function usePostExtractor() {
  function getParsedReviewDate(post: IMarketplaceReviewsPost) {
    if (!post) return;

    const postDate = new Date(post.instagramPost.createdAt);

    const year = postDate.toJSON().split("-")[0];
    const formatted = postDate.toLocaleDateString("ru-RU", {
      day: "numeric",
      month: "long",
    });

    const postDateLocale = `${formatted} ${year}`;

    return postDateLocale;
  }

  function getParsedReviewTime(post: IMarketplaceReviewsPost) {
    const postDate = new Date(post.instagramPost.createdAt);
    const time = postDate.toUTCString().split(" ")[4].slice(0, -3);

    return time;
  }

  return {
    getParsedReviewDate,
    getParsedReviewTime,
  };
}
